var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"top-r-menu-dropdown {{ showList ? 'clicked' : '' }}\"\u003E\u003Ci class=\"material-icons\"\u003Emore_{{ showList ? 'horiz' : 'vert'}}\u003C\u002Fi\u003E\u003Cdiv class=\"dropdown-logout\" ng-if=\"showList\"\u003E\u003Cp ng-repeat=\"item in menuItems\" ng-bind=\"item.title\" ng-click=\"item.callback()\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./app/shared/directives/ng.dropdown.menu/ng.dropdown.menu.pug
// module id = 517
// module chunks = 31